<template>
    <section :id="questionId" class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 troubleshoot-main">
      <!-- All the page html is rendered in this slot -->
      <slot id="pageContent"></slot>
    </section>
</template>

<script>
  /**
  * A `<section>` element to wrap each page / test
  */
  export default {
    name: 'Wrapper',
    data () {
      return {
      }
    },
    props: {
      /**
      * String - Unique identifier and id attribute for the section element
      */
      'questionId': {
        'type': String
      }
    }
  }
</script>
